import { Divider, Segmented, SegmentedProps, Select, SelectProps, Tag } from "antd";
import { DividerProps } from "antd/lib";
import styled from "styled-components";

export const CalendarDiv = styled.div`
    background-color: white;
    padding: 10px;
    width: calc(100% + 24px);
    margin-left: -12px;
`;

export const TextMuted = styled.p`
    color: gray !important;
    font-size: 14px;
    margin: 0 !important;
`;

export const LabelText = styled.p<{ inline?: boolean }>`
    color: #404040 !important;
    font-size: 13px;
    margin: 0 !important;
    margin-bottom: ${({ inline }) => (inline ? "0" : "4px")} !important;
    font-weight: 500;
`;

export const ModalDivider = styled(Divider)<DividerProps>`
    width: calc(100% + 48px);
    margin-left: -24px !important;
    margin-top: 16px;
    margin-bottom: 0;
    background-color: #ffffff !important;
`;

export const TagContainer = styled.div<{ hasItems: boolean }>`
    min-height: ${props => props.hasItems ? '32px' : '0'};
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
`;

export const ModeSegmented = styled(Segmented)<SegmentedProps>`
    &.ant-segmented {
	    background: #f7f7f7 !important;
        box-shadow: inset 0 0 0 2px rgba(187, 187, 187, 0.1) !important;
    }

    .ant-segmented-item-label {
        color: black !important;
    }

    .ant-segmented-item-selected {
        background-color: #47cb38 !important;
        .ant-segmented-item-label {
            color: white !important;
        }
    }

    .ant-segmented-thumb {
        background-color: #47cb38 !important;
        color: black !important;
    }
`;

export const MultiSelect = styled(Select)<SelectProps>`
    .ant-select-selection-overflow-item-rest {
        display: none !important;
    }
`;

export const AnimatedTag = styled(Tag)`
    animation: fadeScale 0.3s ease-in-out;
    margin-right: 3px;
    margin-bottom: 4px;
    transition: all 0.3s ease-in-out;

    &.removing {
        opacity: 0;
        transform: scale(0.9);
        pointer-events: none;
    }

    @keyframes fadeScale {
        from {
            opacity: 0;
            transform: scale(0.9);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }
`;

export const TargetPlatformSelect = styled(Select)<SelectProps>`
    &.ant-select {
       width: 160px;
       .ant-select-selection-item {
           display: flex;
        }
    }
`

export const ModalHeader = styled.span`
    display: flex;
    align-items: center;
    gap: 8px;
`

/**
 * The Amagi OTA promo-break settings, boxed off from the pickers above it so the
 * switch reads as one group of settings rather than another field in the list.
 */
export const PromoBreakPanel = styled.div`
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    padding: 16px;
    background-color: #fafafa;
`;

/** Sub-label under a promo-break control: what it does / what it adds up to. */
export const PromoHint = styled.p`
    color: #8c8c8c !important;
    font-size: 12px;
    margin: 4px 0 0 !important;
`;
